import { Store } from '@tanstack/store';

interface ErrorState {
  isConstructionMode: boolean;
  isNetworkError: boolean;
}

export const errorStore = new Store<ErrorState>({
  isConstructionMode: false,
  isNetworkError: false,
});

export default errorStore;
